export default __webpack_public_path__ + "static/media/obj6.2113743c.jpg";